import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { FILTER_VARIANT_API } from "./apiRoutes";

interface mutateProps {
  id: string;
  data: FieldValues;
}

const mutateUpdateFilterVariants = async ({
  data,
  id
}: mutateProps) => {
  return await axiosAuth.put(`${FILTER_VARIANT_API}/${id}`, data);
};

const useUpdateFilterVariantsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateFilterVariants,
    ...queryParams,
  });

export default useUpdateFilterVariantsMutation;
